import VolleyballSvg from '@assets/images/svg/volleyball.svg';
import React from 'react';
import { View } from 'react-native';

export interface VolleyballIconProps {
    size?: number;
    color?: string;
}

export function VolleyballIcon({ size = 25, color = '#4D4D4D' }: VolleyballIconProps) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <VolleyballSvg width={size} height={size} color={color} />
        </View>
    );
}

export default VolleyballIcon;
